import React from "react";
import '../styles/Footer.css'

function Footer() {
    return (
        <div className={'footer-container'}>
            <footer>
                <p>Created by <a href={'https://github.com/katsofroniou'}>Katerina</a></p>
            </footer>
        </div>
    )
}

export default Footer;